module.exports = __webpack_public_path__ + "img/download.998b55a3.svg";